import { db } from "../firebase";
import {
  doc,
  getDoc,
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
  writeBatch,
  updateDoc,
  setDoc,
  serverTimestamp,
  onSnapshot
} from "firebase/firestore";

export const listenToGifts = (cardId, callback) => {
  if (!cardId) return () => { };

  const q = query(
    collection(db, "cards", cardId, "gifts"),
    orderBy("order", "asc")
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const gifts = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    callback(gifts);
  });

  return unsubscribe;
};

export const reserveGift = async (cardId, giftId, reservationData) => {
  const giftRef = doc(db, "cards", cardId, "gifts", giftId);
  await updateDoc(giftRef, {
    ...reservationData,
    isReserved: true,
    reservedAt: serverTimestamp(),
  });
};

export const createCard = async (cardData, customId = null) => {
  const { programmes = [], contactDetails = [], slotTimes = [], images = [], gifts = [], ...mainData } = cardData;

  // 1. Create the main card document
  let cardId;
  const cardsCollection = collection(db, "cards");

  if (customId) {
    await setDoc(doc(cardsCollection, customId), mainData);
    cardId = customId;
  } else {
    const cardRef = await addDoc(cardsCollection, mainData);
    cardId = cardRef.id;
  }

  const batch = writeBatch(db);

  // 2. Add subcollections

  // Programmes
  programmes.forEach((prog, index) => {
    const ref = doc(collection(db, "cards", cardId, "programmes"));
    batch.set(ref, { ...prog, order: index });
  });

  // Contacts
  contactDetails.forEach((contact, index) => {
    const ref = doc(collection(db, "cards", cardId, "contacts"));
    batch.set(ref, { ...contact, order: index });
  });

  // Slot Times - only if showSlotTime is true
  if (mainData.showSlotTime) {
    slotTimes.forEach((slot, index) => {
      const ref = doc(collection(db, "cards", cardId, "slotTimes"));
      batch.set(ref, { ...slot, order: index });
    });
  }

  // Images
  images.forEach((img, index) => {
    const ref = doc(collection(db, "cards", cardId, "images"));
    batch.set(ref, { ...img, order: index });
  });

  // Gifts
  if (mainData.showGift && gifts && gifts.length > 0) {
    gifts.forEach((gift, index) => {
      const ref = doc(collection(db, "cards", cardId, "gifts"));
      batch.set(ref, { ...gift, order: index, isReserved: false });
    });
  }

  await batch.commit();

  return cardId;
};

export const getCardById = async (cardId) => {
  const cardRef = doc(db, "cards", cardId);
  const cardSnap = await getDoc(cardRef);

  if (!cardSnap.exists()) {
    throw new Error("Card not found");
  }

  return { id: cardSnap.id, ...cardSnap.data() };
};

export const getProgrammes = async (cardId) => {
  const q = query(
    collection(db, "cards", cardId, "programmes"),
    orderBy("order", "asc")
  );

  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getContacts = async (cardId) => {
  const q = query(
    collection(db, "cards", cardId, "contacts"),
    orderBy("order", "asc")
  );

  const snap = await getDocs(q);
  return snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
};

export const getCardImages = async (cardId) => {
  const q = query(
    collection(db, "cards", cardId, "images"),
    orderBy("order", "asc")
  );

  const snap = await getDocs(q);
  return snap.docs.map(doc => doc.data().url);
};


export const listenToWishes = (cardId, callback) => {
  if (!cardId) return () => { };

  const q = query(
    collection(db, "guestWish", cardId, "wishes"),
    orderBy("createdAt", "desc")
  );

  const unsubscribe = onSnapshot(q, (snapshot) => {
    const wishes = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    callback(wishes); // 👈 push data to React
  });

  return unsubscribe; // 👈 VERY IMPORTANT
};
